const experiences = [
  {
    title: "Backend Software Engineer at Shopee ID",
    period: "Feb 2021 - Present",
    content: "I develop a Shopee's gamification application for millions of users across multiple countries. I also maintain some internal shared services within the Shopee's gamification system.",
    isActive: true,
    onDisplay: true,
  },
  {
    title: "Head of IT Dev Department at BEM Fasilkom UI",
    period: "Jan 2020 - Jan 2021",
    content:
      "I led and managed a team of 10 developers to develop new products and maintain previously developed applications. I also analyzed and designed the application developments, as well as providing development guidelines and contributing directly to the development of 3 main projects using Django REST, Laravel, and ReactJS.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "University of Indonesia's CS Undergraduate Teaching Assistant",
    period: "Jan 2018 - Jan 2021",
    content:
      "I was the co-coordinator of the AI class teaching assistant team focussing on Machine Learning basics. Previous positions include: teaching assistant for Programming Fundamentals using Python, Java; and Web Design & Development using Django. I graded, monitored, tutored 15+ students, and led lab sessions.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "Backend Software Engineer Intern at Shopee ID",
    period: "Jun 2020 - Sep 2020",
    content:
      "I provided valuable insights for engineers by developing another version of a game application BE service (previously built using MySQL) using MongoDB, performed connection tuning and load testing on various relevant DB operations, analyzed, and generated a complete proof of concept. On this internship, I also reduced manual labor for the marketing team by creating a service to automate the KOL data collection and update.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "Fullstack Software Engineer Intern at Akselito",
    period: "Apr 2020 - Jun 2020",
    content:
      "As the only engineer intern, I worked and collaborated directly with the founders on product developments and designs for career accelerator products. I maintained the product as well as developing additional user management system around it using Django REST and ReactJS.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "Fullstack Software Engineer Intern at Dekoruma",
    period: "Jan 2020",
    content:
      "I improved Dekoruma engineers' and operators' workflow knowledge by providing an Activity Flow Visualizer with a graph-based guidelines using ReactJS with Redux. This visualizer displays large and complex flows that Dekoruma owns. I also increased engineers’ response time regarding anomalies within the Django-REST based system by creating unlinked data notifiers. I also contributed in reducing manual labor from the finance & operational team by developing purchase takeout endpoints.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "Back End Software Engineer Intern at Stoqo",
    period: "June 2019 - Aug 2019",
    content:
      "I improved Stoqo delivery timeliness by developing a new delivery method implementation using Django REST. I also developed its automated driver scheduler and summarization, further improving the driver-power management. I got the honor to co-initiated Stoqo’s first data pipeline - using Apache Airflow, AWS RDS, Google BigQuery, and many others - providing access to greater data analytics and visualization within the company, while also performing data analytics for delivery timeliness which result is visualized and accessible to operators and engineers via Metabase.",
    isActive: false,
    onDisplay: true,
  },
  {
    title: "IT Dev Staff at BEM Fasilkom UI",
    period: "Feb 2018 - Dec 2018",
    content:
      "My main project was an internal LINE Bot to assist admins by notifying them of submitted user inputs and passing the admins' response through the mobile chat platform. During this period, I also worked on designing and implementing several apps' database modelling and BE service. I also co-implemented a static website: Faculty Introductory Page for new students. In the end of my period, I led and managed the IT Dev class for the next period members.",
    isActive: false,
    onDisplay: false,
  },
];

export default experiences;
